export default __webpack_public_path__ + "static/media/errorIcon.3897d925.png";